const { default: Config } = require("../const/config");
let userSessionInfo;
let patientData;
let analysisName;
var currentAnalysis;
let patientPainData;
export const controller = new AbortController();
export const signal = controller.signal
if (localStorage.getItem("userSessionInfo"))
    userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
let imageDetailMap = new Map();

export function getImage(id, callback) {

    if (!userSessionInfo) {
        userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
    }
    if (imageDetailMap.get(id)) {
        callback(imageDetailMap.get(id))
    } else {
        // imageDetailMap.set(id, 'data')
        fetch(Config.endPointProd + 'fileStorage/' + id, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userSessionInfo.accessToken,
            }
        }, { signal })
            .then(response => {
                if (response.status === 401) {
                    console.log("Invalid Input");
                    callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
                } else if (response.status !== 200) {
                    console.log("Invalid Input");
                    callback({ error: true, message: '', type: '' })
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data) {
                    imageDetailMap.set(id, data);
                    callback(data)
                }
            })
            .catch(function (error) {
                console.log('Request failed', error);
            });
    }


}

export function renewAuthToken() {

}

export function LoginUser(username, password, callback) {
    fetch(Config.endPoint + 'auth/login', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username: username, password: password })
    })
        .then(response => {
            if (response.status === 401) {
                console.log("invalid Input");
                callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
            } else if (response.status !== 200) {
                localStorage.setItem("isLogin", "false");
                callback({ error: true, message: '', type: '' })
            } else {
                return response.json();
            }
        })
        .then(dataLogin => {
            if (dataLogin) {
                localStorage.setItem("isLogin", "true");
                localStorage.setItem("userSessionInfo", JSON.stringify(dataLogin));
                userSessionInfo = dataLogin;
                // setLoading(false);
                fetch(Config.endPoint + 'auth/loggedUser', {
                    method: 'get',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + dataLogin.accessToken,
                    }
                })
                    .then(response => {
                        if (response.status !== 200) {
                            
                            callback({ error: true, message: "Invalid Input" })
                        } else {
                            return response.json();
                        }
                    })
                    .then(dataUser => {
                        if (dataUser) {
                            localStorage.setItem("loggedUserInfo", JSON.stringify(dataUser));


                            fetch(Config.endPoint + 'auth/' + dataUser?.id, {
                                method: 'get',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Bearer ' + dataLogin.accessToken,
                                }
                            })
                                .then(response => {
                                    if (response.status !== 200) {
                                        callback({ error: true, message: "Invalid Input" })
                                    } else {
                                        return response.json();
                                    }
                                })
                                .then(dataProfile => {
                                    if (dataProfile) {
                                        localStorage.setItem("userProfileInfo", JSON.stringify(dataProfile));
                                        callback({ error: false, message: dataProfile })
                                    }
                                })
                                .catch(function (error) {
                                    callback({ error: true, message: "Something went wrong. Please try again later." })
                                });

                            // callback({ error: false, message: data })
                        }
                    })
                    .catch(function (error) {
                        callback({ error: true, message: "Something went wrong. Please try again later." })
                    });
            }
        })
        .catch(function (error) {
            callback({ error: true, message: "Something went wrong. Please try again later." })
        });

}

export function base64ToBuffer(str, callback) {
    fetch(str)
        .then(b => b.arrayBuffer())
        .then(buff => {
            const buf = new Int8Array(buff);
            callback(buf);
        })
        .catch(e => console.log(e))

}

export function getAccessData(callback) {
    if (!userSessionInfo) {
        userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
    }
    const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
    fetch(Config.endPointProd + 'accessLogs/search', {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + userSessionInfo.accessToken,
        },
        body: JSON.stringify({ orgId: loggedUserInfo.orgRef.id })
    })
        .then(response => {
            if (response.status === 401) {
                console.log("Invunalid Input");
                callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
            } else if (response.status !== 200) {
                console.log("Invalid Input");
                callback({ error: true, message: '', type: '' })
            } else {
                return response.json();
            }
        })
        .then(data => {
            callback(data)
        })
        .catch(function (error) {
            console.log('Request failed', error);
        });

}

export function getSliceThumbnailName(callback) {
    if (analysisName) {
        callback(analysisName)
    } else {
        if (!userSessionInfo) {
            userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
        }
        // const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
        fetch(Config.endPointProd + 'patientAnalysis/formatAnalysisOutput', {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                if (response.status === 401) {
                    console.log("Invunalid Input");
                    callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
                } else if (response.status !== 200) {
                    console.log("Invalid Input");
                    callback({ error: true, message: '', type: '' })
                } else {
                    return response.json();
                }
            })
            .then(data => {
                analysisName = data;
                callback(analysisName)
            })
            .catch(function (error) {
                console.log('Request failed', error);
            });
    }

}

export function getAnalysisData(id, callback) {
    let path = `${Config.endPointProd}patientAnalysis/cbd84614-2a7f-4a93-a1fc-92ef06747d0b`;
    if (id) {
        path = `${Config.endPointProd}patientAnalysis/${id}`
    }
    if (!userSessionInfo) {
        userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
    }

    fetch(path, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + userSessionInfo.accessToken,
        }
    })
        .then(response => {
            if (response.status === 401) {
                console.log("Invunalid Input");
                callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
            } else if (response.status !== 200) {
                console.log("Invalid Input");
                callback({ error: true, message: '', type: '' })
            } else {
                return response.json();
            }
        })
        .then(data => {
            currentAnalysis = data;
            callback(data)
        })
        .catch(function (error) {
            console.log('Request failed', error);
        });

}

export function getPatientListData(callback) {
    let path = `${Config.endPointProd}patientAnalysis/search`;

    if (!userSessionInfo) {
        userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
    }

    fetch(path, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + userSessionInfo.accessToken,
        },
        body: JSON.stringify({})
    })
        .then(response => {
            if (response.status === 401) {
                console.log("Invalid Input");
                callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
            } else if (response.status !== 200) {
                console.log("Invalid Input");
                callback({ error: true, message: '', type: '' })
            } else {
                return response.json();
            }
        })
        .then(data => {
            patientData = data;
            callback(data)
        })
        .catch(function (error) {
            console.log('Request failed', error);
        });

}

export function getSelectedPatientData(name, callback) {
    if (patientData) {
        const pData = patientData.find(elem => { return elem.pateintDetails.name === name });
        currentAnalysis = pData;
        callback({ error: false, message: pData });
    } else {
        getPatientListData(data => {
            if (data.error) {
                callback({ error: true, message: '', type: data.type });
            } else {
                const pData = data.find(elem => { return elem.pateintDetails.name === name });
                currentAnalysis = pData;
                callback({ error: false, message: pData });
            }

        })
    }
}

export function updateAnalysisData(comment, diskcode, key, callback) {
    //commentValue, 'L3_L4','negativeFeedback'
    let path = `${Config.endPointProd}patientAnalysis/cbd84614-2a7f-4a93-a1fc-92ef06747d0b`;
    if (currentAnalysis) {
        path = `${Config.endPointProd}patientAnalysis/${currentAnalysis.id}`
    }
    if (currentAnalysis && diskcode) {
        const index = currentAnalysis.spinaAnalysis.diskWisePredictions.findIndex(elem => elem.diskCode === diskcode);
        if (index != null) {
            currentAnalysis.spinaAnalysis.diskWisePredictions[index][key] = comment;
        }
        if (!userSessionInfo) {
            userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
        }

        fetch(path, {
            method: 'put',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userSessionInfo.accessToken,
            },
            body: JSON.stringify(currentAnalysis)
        }).then(response => {
            if (response.status === 401) {
                console.log("Invunalid Input");
                callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
            } else if (response.status !== 200) {
                console.log("Invalid Input");
                callback({ error: true, message: '', type: '' })
            } else {
                return response.json();
            }
        }).then(data => {
            currentAnalysis = data;
            callback(data)
        }).catch(function (error) {
            console.log('Request failed', error);
        });
        // console.log(currentAnalysis);
    }


}

export function getPatientPainListData(id, callback) {
    let path = `${Config.endPointProd}painScale/${id}`;

    if (!userSessionInfo) {
        userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
    }

    fetch(path, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + userSessionInfo.accessToken,
        }
    }).then(response => {
        if (response.status === 401) {
            console.log("Invalid Input");
            callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
        } else if (response.status !== 200) {
            console.log("Invalid Input");
            callback({ error: true, message: '', type: '' })
        } else {

            // patientPainData = response.json()
            // callback(patientPainData);
            return response.json();
        }
    }).then(data => { 
        if (data) {
            patientPainData = data
            callback(data)
        }
    }).catch(function (error) {
        console.log('Request failed', error);
    });
}
export function getPainScaleData(callback) {
    // let path = `${Config.endPointProd}painScale/localizationStructure`;
    let path = `${Config.endPointProd}painScale/localizationStructureNew`;

    if (!userSessionInfo) {
        userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
    }

    fetch(path, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + userSessionInfo.accessToken,
        }
    }).then(response => {
        if (response.status === 401) {
            console.log("Invalid Input");
            callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
        } else if (response.status !== 200) {
            console.log("Invalid Input");
            callback({ error: true, message: '', type: '' })
        } else {
            return response.json();
        }
    }).then(data => {

        callback(data)
    }).catch(function (error) {
        console.log('Request failed', error);
    });
}

export function submitPainScaleData(id, body, callback) {
    let path = `${Config.endPointProd}painScale`;

    if (!userSessionInfo) {
        userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
    }

    const bodyData = { "individualPainLocations": body, "id": id }

    fetch(path, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + userSessionInfo.accessToken,
        },
        body: JSON.stringify(bodyData)
    }).then(response => {
        if (response.status === 401) {
            console.log("Invalid Input");
            callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
        } else if (response.status !== 200) {
            console.log("Invalid Input");
            callback({ error: true, message: '', type: '' })
        } else {
            return response.json();
        }
    }).then(data => {
        if (callback) {
            patientPainData = data
            callback(data)
        }
    }).catch(function (error) {
        console.log('Request failed', error);
    });
}

export function updatePainScaleData(id, body, callback) {
    let path = `${Config.endPointProd}painScale/${id}`;

    if (!userSessionInfo) {
        userSessionInfo = JSON.parse(localStorage.getItem("userSessionInfo"));
    }
      patientPainData.individualPainLocations = patientPainData.individualPainLocations.concat(body);
    const bodyData = { "individualPainLocations": patientPainData.individualPainLocations, "id": id, metaData: patientPainData.metaData };

    console.log(bodyData, patientPainData, body)
    fetch(path, {
        method: 'put',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + userSessionInfo.accessToken,
        },
        body: JSON.stringify(bodyData)
    }).then(response => {
        if (response.status === 401) {
            console.log("Invalid Input");
            callback({ error: true, message: '', type: 'REDIRECTLOGIN' })
        } else if (response.status !== 200) {
            console.log("Invalid Input");
            callback({ error: true, message: '', type: '' })
        } else {
            return response.json();
        }
    }).then(data => {

        patientPainData = data;
        console.log(patientPainData);
        callback(data)

    }).catch(function (error) {
        console.log('Request failed', error);
    });
}


export function getCurrentAnalysis() {
    return currentAnalysis;
} 